export default __webpack_public_path__ + "static/media/Project-6.f32d553d.jpg";